import { Star, Quote, ArrowUpRight } from "lucide-react";
import { REVIEWS, REVIEWERS, MAPS_URL } from "./data";
import { Reveal, Eyebrow } from "./Reveal";

function Stars({ size = "w-4 h-4" }) {
  return (
    <span className="flex gap-1">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className={`${size} fill-gold text-gold`} />
      ))}
    </span>
  );
}

export default function Reviews() {
  return (
    <section
      id="reviews"
      className="relative py-28 md:py-40 bg-obsidian border-y border-white/10 overflow-hidden"
      data-testid="reviews-section"
    >
      <span
        aria-hidden="true"
        className="absolute left-[-8vw] bottom-[-10%] font-arabic text-[40vw] leading-none text-gold/[0.04] select-none pointer-events-none"
      >
        ن
      </span>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <Reveal className="mb-16 md:mb-20">
          <Eyebrow className="mb-4">Word on the street</Eyebrow>
          <h2 className="font-display font-semibold text-4xl md:text-6xl leading-tight">
            Five stars. Three times.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-6">
          <Reveal>
            <div
              data-testid="reviews-summary"
              className="h-full rounded-2xl border border-gold/30 bg-cardc p-8 md:p-10 flex flex-col justify-between"
            >
              <div>
                <div className="font-display font-bold text-8xl md:text-9xl text-gold leading-none">
                  5.0
                </div>
                <div className="mt-4">
                  <Stars size="w-5 h-5" />
                </div>
                <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-dim leading-loose">
                  3 reviews on Google
                  <br />
                  {REVIEWERS.join(" · ")}
                </p>
              </div>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-google-link"
                className="mt-10 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-gold hover:text-ember transition-colors"
              >
                Read on Google
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </Reveal>

          {REVIEWS.map((r, i) => (
            <Reveal key={r.author} delay={0.1 + i * 0.1}>
              <div
                data-testid={`reviews-card-${r.author.toLowerCase().replace(/\s+/g, "-")}`}
                className="h-full rounded-2xl border border-white/10 bg-cardc p-8 md:p-10 flex flex-col transition-colors duration-500 hover:border-ember/40"
              >
                <Quote className="w-7 h-7 text-ember mb-6" />
                <p className="text-bone/90 leading-relaxed text-base md:text-lg flex-1">
                  {r.text}
                </p>
                <div className="mt-8 pt-6 border-t border-white/10">
                  <Stars size="w-3.5 h-3.5" />
                  <p className="mt-3 font-display font-semibold text-xl">
                    {r.author}
                  </p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim mt-1">
                    {r.meta}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
